import React from 'react';
import _ from 'lodash';
import { LogoutOutlined } from '@ant-design/icons';

import DocsLink from '../../../docs/DocsLink';
import docsBookmarks from '../../../../constants/docs';
import NavigationSideExpandedMenuItem from './MenuItem';

const formatItemGroupHeader = (words) => _.words(words).join(' ').toLocaleUpperCase();

const NavigationSideExpandedMenu = ({ onLogout, tenantPath, menuGroups }) => {
  const onClick = (e) => {
    e.preventDefault();
    onLogout();
  };

  return (
    <div className="side-navigation-menu">
      <div className="side-navigation-menu-item-group">
        <a href="." id="vizor-logo-link">
          <img alt="" src="/img/vizor-logo-32x32.png" height="32" width="32" />
          <div style={{ fontSize: 18 }}>Vizor Analytics</div>
        </a>
      </div>
      {Object.entries(menuGroups).map(([header, group]) => (
        <div key={header} className="side-navigation-menu-item-group">
          <div className="side-navigation-menu-item-group-header">
            {formatItemGroupHeader(header)}
          </div>
          {group.map((item) => (
            <NavigationSideExpandedMenuItem tenantPath={tenantPath} key={item.location} {...item} />
          ))}
        </div>
      ))}
      <div className="side-navigation-menu-item-group bottom">
        <DocsLink
          scrolTo={docsBookmarks.headDocs}
          linkClassName="side-navigation-menu-item"
          styleIcon={{ fontSize: 20, marginRight: 5 }}
          text="Help"
        />
        <a className="side-navigation-menu-item" onClick={onClick} onKeyDown={() => {}}>
          <LogoutOutlined style={{ fontSize: 20 }} /> Logout
        </a>
      </div>
    </div>
  );
};

export default NavigationSideExpandedMenu;
